
export default {
  namespaced: true,
  state: {
      aguardando: false,
  },
  getters: {
    aguardando: state => {
        return state.aguardando
    }
  },
  /** MUTACOES SAO SINCRONAS - SEMELHANTES AO COMPUTED */
  mutations: {
      setAguardando: (state, payload) => {
          state.aguardando = payload
      }
  },
  /** ACTOINS SAO ASSINCRONOS */
  actions: {
    
  }
}


// WEBPACK FOOTER //
// ./src/vuex/modulos/controle-store.js